var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PayoutBalanceComponent',{attrs:{"title":"SPs Fee Owed","balanceType":"negative"}})
}
var staticRenderFns = []

export { render, staticRenderFns }